export const LocalStorage = {
    set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    get(key, defaults = undefined) {
        try {
            const data = JSON.parse(localStorage.getItem(key));
            if (data !== null && typeof data !== undefined) {
                return data;
            }
        } catch (e) {}
        return defaults;
    },
};
